export enum GrapBlogsSlugEnums {
	Rules = 'xac-nhan-khai-bao-hang-hoa-korea',
}
